export default __webpack_public_path__ + "static/media/icon_print.debcc209.svg";